module.exports = __webpack_public_path__ + "static/media/busy-rider-marker.a54fbb56.svg";